import axios from 'axios';
import { API_URL } from '../config/api.config';

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
const getAuthInfo = () => {
    const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id || ''
    const token = localStorage.getItem('token');
    return { garageId, token };
};

const createAuthAxios = () => {
    const { token } = getAuthInfo();
    return axios.create({
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
const authAxios = createAuthAxios()

export const analyticsService = {
    async getAnalytics(period: string = 'month') {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/analytics/garage/${garageId}?period=${period}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des analytiques:', error);
            throw error;
        }
    },

    async getInvoices() {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/quotes/invoices/garage/${garageId}`);
            console.log("invoices",response);
            return response;
        } catch (error) {
            console.error('Erreur lors de la récupération des analytiques:', error);
            throw error;
        }
    },
    async downloadInvoicesPDF(invoiceId: string) {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/quotes/invoices/${invoiceId}/download`, {
                responseType: 'blob'
            });

            return response;
        } catch (error) {
            console.error('Erreur lors de la récupération des analytiques:', error);
            throw error;
        }
    },
    async getFinances(period: string = 'all') {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const garageId = user._id;

            if (!garageId) {
                throw new Error('Utilisateur non authentifié');
            }

            const response = await authAxios.get(`/analytics/garage/${garageId}/finances?period=${period}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des finances:', error);
            throw error;
        }
    }
};